export type NonNullable<T> = Exclude<T, null | undefined>;

/**
 * Filters out empty values from an array
 * Example usage: [1, undefined, 2, 3, null].filter(notEmpty) --> [1, 2, 3]
 * @param value
 */
export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
	return value !== null && value !== undefined;
}

/**
 * Ensures that a value is defined and not null or undefined
 * @param value
 *
 * @throws Error if value is undefined or null
 */
export function ensureDefined<T>(value: T | undefined | null): T {
	if (value === undefined || value === null) {
		throw new NloUnknownError({ message: 'Value should be defined' });
	}

	return value;
}
